import { CurrentTestState } from "@app/storage"
import { useCallback, useMemo, useState } from "react"
import { useSnapshot } from "valtio"
import { UseAnswerMaskingControl } from "../types"

export const useAnswerMaskingControl = (): UseAnswerMaskingControl => {
  const { currentItemResponse: { itemId } } = useSnapshot(CurrentTestState)

  const [answerMaskingEnabled, setAnswerMaskingEnabled] = useState<boolean>(false)
  const [answerIdsWithMaskByItemId, setAnswerIdsWithMaskByItemId] = useState<Record<string, string[]>>({})

  const answerIdsWithMaskByCurrentItem = useMemo(() => {
    if (!answerMaskingEnabled) return []

    return answerIdsWithMaskByItemId[itemId]
  }, [itemId, answerMaskingEnabled, answerIdsWithMaskByItemId])

  const toggleMaskOnAnswer: (answerId: string) => void = useCallback(
    (answerId: string) => {
      setAnswerIdsWithMaskByItemId(prevState => {
        const answerIds = prevState[itemId] || []
        const isAnswerIdExist = answerIds.includes(answerId)

        if (isAnswerIdExist) {
          return {
            ...prevState,
            [itemId]: answerIds.filter(id => id !== answerId),
          }
        }

        return {
          ...prevState,
          [itemId]: [...answerIds, answerId],
        }
      })
    },
    [itemId],
  )

  const toggleAnswerMasking: (value: boolean) => void = useCallback((value: boolean) => {
    setAnswerMaskingEnabled(value)
  }, [])

  return {
    answerMaskingEnabled,
    answerIdsWithMaskByCurrentItem,
    toggleAnswerMasking,
    toggleMaskOnAnswer
  }
}